var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import { GraphqlQueryStore, } from '@proscom/prostore-apollo';
import { useRequestStore } from '@proscom/prostore-react';
import { useContextApolloClient } from './ApolloClientsContext';
export function useGraphqlQuery(_a) {
    var client = _a.client, queryOptions = _a.queryOptions, variables = _a.variables, options = _a.options;
    var actualClient = useContextApolloClient(client);
    var store = useMemo(function () {
        return new GraphqlQueryStore(__assign({ client: actualClient }, queryOptions));
    }, [actualClient, queryOptions]);
    return useRequestStore(store, variables, options);
}
export function useGraphqlQueryVars(_a) {
    var variableCreator = _a.variableCreator, queryProps = __rest(_a, ["variableCreator"]);
    var variables = useMemo.apply(void 0, variableCreator);
    return useGraphqlQuery(__assign({}, queryProps, { variables: variables }));
}
//# sourceMappingURL=useGraphqlQuery.js.map